import { formatString } from '../../utils/stringHandlers';
import { ReactNode } from 'react';
interface IChipProps {
  title: string | undefined; // title is a required string
  value?: string; // value is an optional string
  color?: string; // color is an optional string with specific values
  type?: 'chip' | 'oval'; // type is an optional string with specific values
  size?: 'md' | 'sm'; // size is an optional string with specific values
  isFormatting?: boolean; // is formatting optional
  icon?: ReactNode;
}

const Chip = ({
  title,
  value,
  type = 'chip',
  size = 'md',
  isFormatting = true,
  icon,
}: IChipProps) => {
  let className = '';

  switch (title) {
    case 'SUBMITTED':
      className += 'bg-ds-orange-100 text-orange-900';
      break;
    case 'RESUBMITTED':
      className += 'bg-ds-orange-100 text-orange-900';
      break;

    case 'IN PROGRESS':
      className += 'bg-ds-purple-200 text-ds-purple-700';
      break;

    case 'REJECTED':
      className += 'bg-ds-red-200 text-red-900';
      break;

    case 'APPROVED':
      className += 'bg-ds-green-200 text-green-700';
      break;

    case 'PUBLISHED':
      className += 'bg-ds-green-200 text-ds-green-800 font-semibold';
      break;

    case 'REQUESTED REVIEW':
    case 'USER EDITS REQUESTED':
    case 'REVIEW AND EDITS REQUESTED':
    case 'REQUESTED CHANGES':
      className += 'bg-ds-orange-200 text-orange-900 font-semibold';
      break;

    case 'AWAITING USER REVIEW':
      className += 'bg-ds-steel-blue-100  text-ds-steel-blue-800 font-semibold';
      break;

    case 'DRAFT':
    case 'UNSPECIFIED':
      className += 'bg-ds-cool-gray-200 text-ds-cool-gray-700 font-semibold';
      break;

    default:
      className += 'bg-primary-200 text-primary-800';
  }

  switch (type) {
    case 'oval':
      className += '  rounded-lg p-1 py-1';
      break;
    case 'chip':
      className += ' rounded-3xl ';
      break;
  }

  switch (size) {
    case 'md':
      className += ' px-4 py-2 ';
      break;
    case 'sm':
      className += ' text-sm px-3 py-1 font-semibold ';
      break;
  }

  return (
    <div
      data-testid="chip-container"
      className={`${className} flex items-center gap-1`} // Add flex styling
      style={{ width: type === 'chip' ? 'fit-content' : '' }}
    >
      {value != null && <h2 className="text-xs font-bold">{value}</h2>}

      {icon && <span className="mr-1">{icon}</span>}

      <h1 className="truncate">{isFormatting ? formatString(title) : title}</h1>
    </div>
  );
};

export default Chip;
